import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { api } from '../api/client';
import type { RankingEntry } from '../api/types';

interface RankingResponse {
  top: RankingEntry[];
  all: RankingEntry[];
}

export default function RankingPage() {
  const { roundId } = useParams();
  const { data } = useQuery({
    queryKey: ['ranking', roundId],
    queryFn: async () =>
      (await api.get<RankingResponse>(`/rounds/${roundId}/ranking`)).data,
    refetchInterval: 60_000,
  });

  if (!data) return <div>Carregando…</div>;

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Ranking — Rodada {roundId}</h2>

      <section className="card">
        <h3 className="font-semibold mb-2">Top {data.top.length} — Ganhadores</h3>
        <ol className="space-y-1">
          {data.top.map((e) => (
            <li key={e.bet_id} className="flex justify-between text-sm border-b py-1">
              <span>
                {e.position}º — {e.user_name || 'Anônimo'}
              </span>
              <strong>{e.points} pts</strong>
            </li>
          ))}
        </ol>
      </section>

      <section className="card">
        <h3 className="font-semibold mb-2">Classificação completa</h3>
        <ol className="space-y-1 text-sm">
          {data.all.map((e) => (
            <li key={e.bet_id} className="flex justify-between border-b py-1">
              <span>
                {e.position}º — {e.user_name || 'Anônimo'}
              </span>
              <span>{e.points} pts</span>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
}
